import { Component } from 'react';
import html2canvas from 'html2canvas';

class InfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], { type: mimeString });
    }

    print = async () => {
        const { selectedArea } = this.props;

        let latitude = null;
        let longitude = null;

        if (selectedArea.type === 'cidade' && selectedArea.buildings[0]) {
            latitude = selectedArea.buildings[0].location.coordinates[1];
            longitude = selectedArea.buildings[0].location.coordinates[0];
        } else if (selectedArea.type === 'Círculo') {
            latitude = selectedArea.getCenter().lat();
            longitude = selectedArea.getCenter().lng();
        } else if (selectedArea.type === 'Retângulo') {
            const bounds = selectedArea.getBounds();
            latitude = (bounds.getNorthEast().lat() + bounds.getSouthWest().lat()) / 2;
            longitude = (bounds.getNorthEast().lng() + bounds.getSouthWest().lng()) / 2;
        }

        await this.props.getImageMapaUrl();
        const base64Image = this.props.mapScreenCaptureDataForPDF;

        const formData = new FormData();

        if (base64Image) {
            formData.append('mapaImage', base64Image);
        }

        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('buildings', JSON.stringify(selectedArea.buildings || []));
        formData.append('users', JSON.stringify(selectedArea.users || []));

        try {
            const response = await axios.post('/georeferenciamento/print', formData, {
                responseType: 'blob'
            });

            const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'georeferenciamento.pdf');
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);

        } catch (error) {
            console.error("Erro ao gerar PDF", error);
        }
    };



    render() {
        const { type, selectedArea } = this.props;

        const iconByType = {
            "Círculo": "fa-circle",
            "Círculo Manual": "fa-circle",
            "Polígono": "fa-draw-polygon",
            "Retângulo": "fa-square",
        };

        return (
            <div className="info-card area-info ov-hidden mt-mb-2">
                <hr className="info-card-hr hr-mapa" />

                {
                    type.toLowerCase() != 'cidade' &&
                    <div className="info-card-header card-header">
                        <i className={`fa-solid ${iconByType[selectedArea.type] || ""}`} style={{ color: selectedArea.color }}></i>
                        {" "}{isNaN(selectedArea.name) ? selectedArea.name : `${type.split(' ')[0]} ${selectedArea.name}`}{ }
                    </div>
                }

                <div className="card-body card-body-mapa-info">
                    <div className='font19'>
                        <span className="">Tipo da busca:</span> {selectedArea.type.toLowerCase()}
                    </div>

                    {selectedArea.radius !== undefined && (
                        <div className='font19'>
                            <span className="">Raio do círculo:</span> {Number(selectedArea.radius).toFixed(2)}
                        </div>
                    )}


                    <div className='font19'><span className="info-card-label">Total de usuários:</span> {selectedArea?.users?.length}</div>
                    <div className='font19'><span className="info-card-label">Total de empreendimentos:</span> {selectedArea?.buildings?.length}</div>
                </div>

                <div className="info-card-btn-row">
                    <button onClick={this.print} className="info-card-btn info-card-btn-pdf">PDF</button>

                </div>
                <hr className="info-card-hr hr-mapa" />

            </div>
        );
    }
}

export default InfoCard;
